import React, { useState } from "react";
import { Row, Col, Toast, Button } from "react-bootstrap";
import ContentLoader from "react-content-loader";
import { Translation } from "react-i18next";
import moment from "moment";
import { allStates } from "./statesData";
const momentTimeZone = require("moment-timezone");
const CustomContentAlert = (value) => {
  const [show, setShow] = useState(true);
  return (
    <Row>
      <Col md={12}>
        <Toast
          style={{ position: "center" }}
          onClose={() => setShow(false)}
          show={show}
          delay={4000}
          autohide
          className={value.className}
        >
          <Toast.Header style={{ position: "right" }}></Toast.Header>
          <Toast.Body>{value.message}</Toast.Body>
        </Toast>
      </Col>
    </Row>
  );
};

export const tableHeightScrollBars = () => {
  const bodyHeight = document.body.scrollHeight;
  const navbarHeight = document.getElementsByClassName("navbar")[0]
    ?.scrollHeight
    ? document.getElementsByClassName("navbar")[0]?.scrollHeight
    : null;
  const filterHeaderHeight =
    document.getElementsByTagName("header")[0].offsetHeight;
  const footerHeight =
    document.getElementsByClassName("fixed-bottom")[0].offsetHeight;
  const finalHeight =
    bodyHeight - (navbarHeight + filterHeaderHeight + footerHeight + 100);
  return finalHeight + "px";
};

export const tableHeightScrollBarsTab = () => {
  const bodyHeight = document.body.scrollHeight;
  const navbarHeight =
    document.getElementsByClassName("navbar")[0].scrollHeight;
  const navtabsHeight =
    document.getElementsByClassName("nav-tabs")[0].scrollHeight;
  const navtabsHeaderHeight =
    document.getElementsByTagName("header")[0].offsetHeight;
  const footerHeight =
    document.getElementsByClassName("fixed-bottom")[0].offsetHeight;
  const finalHeight =
    bodyHeight -
    (navbarHeight + navtabsHeight + navtabsHeaderHeight + footerHeight + 144);
  return finalHeight + "px";
};

export const regExForPhone =
  /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i;
export const isEmailValid = (email) => {
  const regExForEmail =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const isEmailValidate = regExForEmail.test(String(email).toLowerCase());
  return isEmailValidate;
};

export const validation_message = (
  constName,
  msgName,
  validName,
  driverSide
) => {
  if (driverSide) {
    const errorMsg = msgName + "Required.";
    return !constName && !validName ? (
      <div className="help-block">
        <Translation>{(t) => <>{t(errorMsg)}</>}</Translation>
      </div>
    ) : (
      <div></div>
    );
  } else {
    return !constName && !validName ? (
      <div className="help-block">{`${msgName} is required`}</div>
    ) : (
      <div></div>
    );
  }
};

export const contentLoader = () => {
  return (
    <ContentLoader
      speed={1}
      backgroundColor={"#b6b6b6"}
      foregroundColor={"#898989"}
      viewBox="0 0 380 250"
    >
      <circle cx="30" cy="50" r="30" />
      <rect x="230" y="17" rx="4" ry="4" width="150" height="20" />
      <rect x="330" y="50" rx="3" ry="3" width="50" height="20" />
      <rect x="0" y="170" rx="3" ry="3" width="200" height="40" />
    </ContentLoader>
  );
};

export const validations = (targetName, fieldNames, fieldValue) => {
  if (targetName === fieldNames && fieldValue.trim().length === 0) {
    return { value: "", validator: false };
  } else {
    return {
      value: fieldValue,
      validator: true,
    };
  }
};

export const email_validation_message = (
  email,
  validEmail,
  wrongEmail,
  driverSide
) => {
  if (driverSide) {
    const emailRequiredMsg = "EmailRequired.";
    const emailInvalidMsg = "EmailIncorrect.";
    return !email.trim().length && !validEmail ? (
      <div className="help-block">
        <Translation>{(t) => <>{t(emailRequiredMsg)}</>}</Translation>
      </div>
    ) : (
      email && wrongEmail && (
        <div className="help-block">
          {" "}
          <Translation>{(t) => <>{t(emailInvalidMsg)}</>}</Translation>
        </div>
      )
    );
  } else {
    return !email?.trim().length && !validEmail ? (
      <div className="help-block">Email is required</div>
    ) : (
      email && wrongEmail && <div className="help-block">Invalid Email</div>
    );
  }
};

export const findBySearch = (
  searchValue,
  list,
  oldList,
  columnList,
  timezone
) => {
  let newItems = [];
  if (searchValue && searchValue.trim().length === 0) {
    newItems = oldList;
  } else {
    (list ?? []).filter((item) => {
      const temp1 = false;
      let filteredItem;
      item &&
        (Object.keys(item) ?? []).map((ele) => {
          let tempResult;
          if (!columnList || columnList.includes(ele)) {
            if (timezone) {
              if (
                ele === "created_at" ||
                ele === "IssuedDate" ||
                ele === "time_of_action" ||
                ele === "deactivation_time" ||
                ele === "ticket_time" ||
                ele === "transaction_time" ||
                ele === "end_time" ||
                ele === "entry_time" ||
                ele === "permit_created_at" ||
                ele === "createdAt"
              ) {
                let date;
                if (ele === "IssuedDate") {
                  date = utcToSpecificTimeZone(timezone, item[ele], true);
                } else if (ele === "permit_created_at") {
                  date = moment(item[ele]).format("lll");
                } else {
                  date = utcToSpecificTimeZone(timezone, item[ele]);
                }
                const temp2 = date
                  .toLowerCase()
                  .includes(searchValue?.toLowerCase());
                tempResult = temp1 || temp2 ? temp2 : false;
                tempResult && (filteredItem = item);
                return tempResult;
              }
            }
            if (typeof item[ele] === "number") {
              const temp2 = item[ele].toString().includes(searchValue);
              tempResult = temp1 || temp2 ? temp2 : false;
              tempResult && (filteredItem = item);
              return tempResult;
            } else {
              const temp2 =
                item[ele] &&
                item[ele] !== (true || false) &&
                typeof item[ele] !== "object" &&
                item[ele].trim().length &&
                item[ele].toLowerCase().includes(searchValue?.toLowerCase());
              tempResult = temp1 || temp2 ? temp2 : false;
              tempResult && (filteredItem = item);
              return tempResult;
            }
          }
          return tempResult;
        });
      filteredItem && newItems.push(filteredItem);
      return [];
    });
  }
  return newItems;
};

export const checkWord = (item, searchValue) => {
  const tolower = searchValue.toLowerCase();
  item.toLowerCase().includes(tolower);
};

export const routing_using_history = (path) => {
  const history = require("../history").default;
  history.push({
    pathname: path,
  });
};

export const lotselection = (allLots, aliasName) => {
  let lotId = "";
  // const result = allLots.filter((item) => {
  allLots.filter((item) => {
    if (item.alias === aliasName) {
      lotId = item.lot_id;
    }
    return lotId;
  });
  return lotId;
};

export const navigationButtons = (
  previousLocation,
  nextLocation,
  property_id,
  addActionRef,
  currentButton,
  isNextButtonDisable,
  isThereVisitorLot,
  handleAlertOnVisitorLot,
  addClicked
) => {
  const disable = !previousLocation.length && true;
  const history = require("../history").default;
  let nextButtonDisablity = false;
  if (previousLocation === "/settings" || previousLocation === "/adduserform") {
    nextButtonDisablity = isNextButtonDisable;
  }
  return (
    <Row
      className={
        currentButton === "Add Lot" ||
        currentButton === "Add Lane" ||
        currentButton === "Add Camera" ||
        currentButton === "Add User" ||
        currentButton === "Add Edge Device" ||
        currentButton === "Citation Setup Template"
          ? "bottom-footer-btn m-0"
          : "bottom-footer-btn right-side m-0 mt-3"
      }
    >
      {currentButton === "Add Lot" ||
      currentButton === "Add Lane" ||
      currentButton === "Add Camera" ||
      currentButton === "Add User" ||
      currentButton === "Citation Setup Template" ||
      currentButton === "Add Edge Device" ? (
        <Col md="auto" className="pt-3 pl-0">
          {currentButton === "Add Edge Device" ||
          currentButton === "Add User" ? (
            <Button className="btn-blue-bg" onClick={addClicked}>
              {currentButton}
            </Button>
          ) : (
            <Button
              className="btn-blue-bg"
              onClick={() => addActionRef.current.click()}
            >
              {currentButton}
            </Button>
          )}
        </Col>
      ) : null}

      <Col md="auto" className="d-flex justify-content-end pt-3 pr-0">
        <div style={{ display: "flex" }}>
          <Button
            style={{ marginRight: "0.5rem" }}
            className="btn-fill"
            variant="danger"
            onClick={() => {
              history.push({
                pathname: previousLocation,
                search: property_id,
              });
            }}
            disabled={disable}
          >
            Back
          </Button>
          <div
            onClick={() => {
              if (previousLocation === "/settings" && !isThereVisitorLot) {
                handleAlertOnVisitorLot();
              } else if (previousLocation === "/permissions") {
                history.push({
                  pathname: "/landingpage",
                });
              } else {
                history.push({
                  pathname: nextLocation,
                  search: property_id,
                });
              }
            }}
          >
            <Button
              variant={previousLocation === "/permissions" ? "success" : "info"}
              disabled={nextButtonDisablity}
              // disabled={
              //   previousLocation === "/settings"
              //     ? isNextButtonDisable
              //     : !property_id.length && true
              // }
              className="btn-fill"
            >
              {previousLocation === "/permissions" ? "Finish" : "Next"}
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  );
};

/* To covert date according to property timezone */

export const tzDate = (timezone, date) => {
  const dateToBePassed = date || "";
  const moment = require("moment-timezone");
  return moment(dateToBePassed).tz(timezone)?.format("lll");
};

/* ---------------- Creating ZPL file and Printing it to Zebra ---------------- */

export const generateZplFile = async (ticketData) => {
  console.log("===========ticket", ticketData, process.env.NODE_ENV);
  let stateAbbreviation = "";
  const filteredState = allStates.filter(
    (item) => item.value === ticketData.state_name
  );
  if (filteredState && filteredState.length) {
    stateAbbreviation = filteredState[0].label;
  } else {
    stateAbbreviation = ticketData.state_name;
  }
  const plate = `${ticketData.lpn} ${ticketData.country_name || ""} ${
    stateAbbreviation || ""
  }`;
  const enforcer =
    ticketData.user && ticketData.user.last_name
      ? ticketData.user.last_name
      : "-";
  let date = ticketData.created_at
    ? momentTimeZone
        .tz(ticketData.created_at, "UTC")
        .tz(ticketData.property.timezone)
        .format("lll")
    : "-";
  let carColor = ticketData.car_color;
  if (ticketData.language === "fn") {
    date = getDateInFrenchLanguage(date);
    carColor = getColorInFrenchLanguage(ticketData.car_color);
  }
  let note = ticketData.notes_internal ? ticketData.notes_internal : "-";
  const feeStructure = [];
  if (ticketData.property.reasons) {
    ticketData.reasons.forEach((rs) => {
      const currentReason = ticketData.property.reasons.find(
        (s) => s.id === rs.id
      );
      if (currentReason.reason_costs) {
        const sortedCost = currentReason.reason_costs.sort((a, b) =>
          a.period_in_days > b.period_in_days ? 1 : -1
        );
        feeStructure.push({
          title: currentReason.title,
          fees: sortedCost,
        });
      }
    });
  }
  let feesString = "";
  let reasonLength = 0;
  if (ticketData.language === "fn") {
    feeStructure.forEach((s) => {
      if (s.title) {
        const reasonTitle = s.title;
        if (reasonTitle.length > 52) {
          reasonLength = reasonLength + 1;
        }
      }
      if (s.fees && s.fees.length > 0) {
        s.fees.sort((a, b) => (Number(a.cost) > Number(b.cost) ? -1 : 1));

        let index = s.fees.length - 1;
        let fee = s.fees[index].cost;
        let updatedFee = fee.replace(".", ",");
        if (index > 0) {
          // eslint-disable-next-line
          feesString += `${s.title} \\& ${updatedFee}$ si payé dans les ${s.fees[index].period_in_days} jours \\&`;
          for (index = index - 1; index > 0; index--) {
            fee = s.fees[index].cost;
            updatedFee = fee.replace(".", ",");
            // eslint-disable-next-line
            feesString += `${updatedFee}$ si payé entre ${
              s.fees[index + 1].period_in_days + 1
            } - ${s.fees[index].period_in_days} jours \\&`;
          }
          fee = s.fees[index].cost;
          updatedFee = fee.replace(".", ",");
          // eslint-disable-next-line
          feesString += `${updatedFee}$ si payé après ${
            s.fees[index + 1].period_in_days
          } jours \\&`;
        } else {
          // eslint-disable-next-line
          feesString += `${s.title} \\&${updatedFee}$ \\&`;
        }
      } else {
        // eslint-disable-next-line
        feesString += `${s.title} \\&`;
      }
    });
  } else {
    feeStructure.forEach((s) => {
      if (s.title) {
        const reasonTitle = s.title;
        if (reasonTitle.length > 52) {
          reasonLength = reasonLength + 1;
        }
      }
      if (s.fees && s.fees.length > 0) {
        s.fees.sort((a, b) => (Number(a.cost) > Number(b.cost) ? -1 : 1));

        let index = s.fees.length - 1;
        if (index > 0) {
          // eslint-disable-next-line
          feesString += `${s.title} \\&$${s.fees[index].cost} if paid within ${s.fees[index].period_in_days} days \\&`;
          for (index = index - 1; index > 0; index--) {
            // eslint-disable-next-line
            feesString += `$${s.fees[index].cost} if paid between ${
              s.fees[index + 1].period_in_days + 1
            } - ${s.fees[index].period_in_days} days \\&`;
          }
          // eslint-disable-next-line
          feesString += `$${s.fees[index].cost} if paid after ${
            s.fees[index + 1].period_in_days
          } days \\&`;
        } else {
          // eslint-disable-next-line
          feesString += `${s.title} \\&$${s.fees[index].cost} \\&`;
        }
      } else {
        // eslint-disable-next-line
        feesString += `${s.title} \\&`;
      }
    });
  }
  const ticketAddress = ticketData.property.address;
  const zone = ticketData.property.domain || ticketData.property.subdomain;
  const payUrl = getPaymentUrl(ticketData);

  let valueForZone = 426; // 458
  if (ticketAddress.length > 52) {
    valueForZone = 426 + 32;
  }
  const valueForVio = valueForZone + 32; // 490
  const check_number = (feesString.match(/\\&/g) || []).length;
  let valueForNote = 32 * check_number + valueForVio + 5; // 842
  if (check_number > 4) {
    valueForNote = valueForNote + 8;
  }
  if (reasonLength === 1) {
    valueForNote = valueForNote + 32;
  }
  if (reasonLength === 2) {
    valueForNote = valueForNote + 64;
  }
  let noteLineDifference = 32;
  const chr = "\\&";
  if (note.length > 40 && note.length < 81) {
    note = note.substring(0, 40) + chr + note.substring(40, note.length);
    noteLineDifference = 64;
  } else if (note.length > 80) {
    const notefirst =
      note.substring(0, 40) + chr + note.substring(40, note.length);
    note =
      notefirst.substring(0, 82) +
      chr +
      notefirst.substring(82, notefirst.length);
    noteLineDifference = 96;
  }
  const valueForPayment = valueForNote + noteLineDifference + 5; // 938
  const valueForCode = valueForPayment + 32; // 970
  let data = "^XA";
  data += "^CI28";
  if (ticketData.language === "fn") {
    data += "^POI";
    data += `^FO40,138^A0,27^FB230,1,10,L,0^FDNum.Réclamation^FS`;
    data += `^FO40,170^A0,27^FB230,1,10,L,0^FDDate^FS`;
    data += `^FO40,202^A0,27^FB230,1,10,L,0^FDImmatriculation^FS`;
    data += `^FO40,234^A0,27^FB230,1,10,L,0^FDNSV^FS`;
    data += `^FO40,266^A0,27^FB230,1,10,L,0^FDMarque^FS`;
    data += `^FO40,298^A0,27^FB230,1,10,L,0^FDModele^FS`;
    data += `^FO40,330^A0,28^FB230,1,10,L,0^FDCouleur^FS`;
    data += `^FO40,362^A0,28^FB230,1,10,L,0^FDAgent^FS`;
    data += `^FO40,394^A0,28^FB230,2,10,L,0^FDAdresse^FS`;
    data += `^FO40,${valueForZone}^A0,28^FB230,1,10,L,0^FDZone^FS`;
    data += `^FO40,${valueForVio}^A0,28^FB230,10,10,L,0^FDViolation^FS`;
    data += `^FO40,${valueForNote}^A0,28^FB230,3,10,L,0^FDNote^FS`;
    data += `^FO40,${valueForPayment}^A0,28^FB230,1,10,L,0^FDPaiement^FS`;
    data += `^FO40,${valueForCode}^A0,28^FB230,4,10,L,0^FDQr Code^FS`;
  } else {
    data += "^POI";
    data += `^FO40,138^A0,28^FB230,1,10,L,0^FDCitation No^FS`;
    data += `^FO40,170^A0,28^FB230,1,10,L,0^FDDate^FS`;
    data += `^FO40,202^A0,28^FB230,1,10,L,0^FDPlate^FS`;
    data += `^FO40,234^A0,28^FB230,1,10,L,0^FDVIN^FS`;
    data += `^FO40,266^A0,28^FB230,1,10,L,0^FDCar Make^FS`;
    data += `^FO40,298^A0,28^FB230,1,10,L,0^FDCar Model^FS`;
    data += `^FO40,330^A0,28^FB230,1,10,L,0^FDCar Color^FS`;
    data += `^FO40,362^A0,28^FB230,1,10,L,0^FDEnforcer^FS`;
    data += `^FO40,394^A0,28^FB230,2,10,L,0^FDAddress^FS`;
    data += `^FO40,${valueForZone}^A0,28^FB230,1,10,L,0^FDZone^FS`;
    data += `^FO40,${valueForVio}^A0,28^FB230,10,10,L,0^FDViolation^FS`;
    data += `^FO40,${valueForNote}^A0,28^FB230,3,10,L,0^FDNote^FS`;
    data += `^FO40,${valueForPayment}^A0,28^FB230,1,10,L,0^FDPayment Url^FS`;
    data += `^FO40,${valueForCode}^A0,28^FB230,4,10,L,0^FDQr Code^FS`;
  }
  data += `^FO242,138^A0,24^FB560,1,10,L,0^FD${ticketData.ticket_no}^FS`;
  data += `^FO242,170^A0,24^FB560,1,10,L,0^FD ${date}^FS`;
  data += `^FO242,202^A0,24^FB560,1,10,L,0^FD${plate}^FS`;
  data += `^FO242,234^A0,24^FB560,1,10,L,0^FD${ticketData.vin}^FS`;
  data += `^FO242,266^A0,24^FB560,1,10,L,0^FD${ticketData.car_make}^FS`;
  data += `^FO242,298^A0,24^FB560,1,10,L,0^FD${ticketData.car_model}^FS`;
  data += `^FO242,330^A0,24^FB560,1,10,L,0^FD${carColor}^FS`;
  data += `^FO242,362^A0,24^FB560,1,10,L,0^FD${enforcer}^FS`;
  data += `^FO242,394^A0,24^FB560,2,10,L,0^FD${ticketAddress}^FS`;
  data += `^FO242,${valueForZone}^A0,24^FB560,1,10,L,0^FD${zone}^FS`;
  data += `^FO242,${valueForVio}^A0,24^FB560,10,10,L,0$^FD${feesString}^FS`;
  data += `^FO242,${valueForNote}^A0,24^FB560,3,10,L,0^FD${note}^FS`;
  data += `^FO242,${valueForPayment}^A0,24^FB560,1,10,L,0^FD${payUrl}^FS`;
  data += `^FO310,${valueForCode}^FD^BQN,2,6^FDQA,${payUrl}^FS`;
  data += `^XZ`;
  return data;
};

export const sendFileToZebra = (selected_device, fileUrl) => {
  return selected_device.sendFile(fileUrl, undefined, errorCallback);
};

const getPaymentUrl = (ticket) => {
  const domain = ticket?.property.domain;
  const subdomain = ticket?.property.subdomain || "-";
  const plate = `${ticket.lpn} ${ticket.country_name || ""} ${
    ticket.state_name || ""
  }`;
  const { ticket_no: id } = ticket;
  const plateCharacters = plate.substring(0, 3);
  const url = `${plateCharacters}-${id}`;

  let paymentUrl;
  const windowUrl =
    window && window.location && window.location.href.split("/");
  const baseUrl = windowUrl[0];
  if (baseUrl === "https:") {
    const newurl = windowUrl[2].split(".");
    if (newurl[2] === "dev") {
      if (
        ticket.property.property_id === "d472ebed-942f-49a3-99b3-b1bd2efba5ff"
      ) {
        paymentUrl = `https://statpark.${process.env.REACT_APP_DRIVER_URL}/td/${url}`;
      } else {
        paymentUrl = `https://${domain || subdomain}.${
          process.env.REACT_APP_DRIVER_URL
        }/td/${url}`;
      }
    } else {
      if (
        ticket.property.property_id === "2d4ab914-4e95-4ce4-8eff-57988f6acaa3"
      ) {
        paymentUrl = `https://statpark.${process.env.REACT_APP_DRIVER_URL}/td/${url}`;
      } else {
        paymentUrl = `https://${domain || subdomain}.${
          process.env.REACT_APP_DRIVER_URL
        }/td/${url}`;
      }
    }
  } else {
    paymentUrl = `${process.env.REACT_APP_PAYMENT_URL}/td/${url}`;
  }
  return paymentUrl;
};

const errorCallback = (errorMessage) => {
  console.log("in error callback");
  alert("Error: " + errorMessage);
};

const getDateInFrenchLanguage = (date) => {
  const English = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const French = [
    "janv.",
    "févr.",
    "mars",
    "avril",
    "mai",
    "juin",
    "juil.",
    "août",
    "sept.",
    "oct.",
    "nov.",
    "déc.",
  ];
  const month = date.substring(0, 3);
  const index = English.indexOf(month);
  return date.replace(month, French[index]);
};

const getColorInFrenchLanguage = (color) => {
  const English = [
    "White",
    "Black",
    "Gray",
    "Silver",
    "Red",
    "Blue",
    "Brown",
    "Green",
    "Beige",
    "Orange",
    "Gold",
    "Yellow",
    "Purple",
  ];
  const French = [
    "Blanc",
    "Noir",
    "Gris",
    "Argent",
    "Rouge",
    "Bleu",
    "Marron",
    "Vert",
    "Beige",
    "Orange",
    "Or",
    "Jaune",
    "Violet",
  ];

  const index = English.indexOf(color);
  return French[index];
};

export const getBlobUrl = (zplData, type) => {
  let fileType = "file/zpl";
  if (type === "png") {
    fileType = "file/png";
  } else if (type === "pdf") {
    fileType = "file/pdf";
  }
  const blob = new Blob([zplData], { type: fileType });
  return window.URL.createObjectURL(blob);
};

/* ---------------- Creating ZPL file and Printing it to Zebra ---------------- */

export const utcToSpecificTimeZone = (timezone, date, time) => {
  try {
    if (time) {
      return momentTimeZone
        .tz(date, "UTC")
        .tz(timezone)
        .format("MMMM DD, YYYY");
    } else {
      return momentTimeZone.tz(date, "UTC").tz(timezone).format("lll");
    }
  } catch (e) {
    console.log("ERROR:: in utcToSpecificTimeZone", e);
  }
};

export const convertPropertyTimeToUtc = (
  timezone,
  startDate,
  endDate,
  withTime
) => {
  try {
    let startDateWithTime = "";
    let endDateWithTime = "";
    if (withTime) {
      startDateWithTime = moment(startDate).format("YYYY-MM-DD HH:mm:SS");
      endDateWithTime = moment(endDate).format("YYYY-MM-DD HH:mm:SS");
    } else {
      const formatStartDate = moment(startDate).format("YYYY-MM-DD");
      startDateWithTime = `${formatStartDate} 00:00:00`;

      const formatEndDate = moment(endDate).format("YYYY-MM-DD");
      endDateWithTime = `${formatEndDate} 23:59:59`;
    }
    const convertedStartTime = moment.tz(startDateWithTime, timezone).format();
    const startDateInUtc = moment
      .tz(convertedStartTime, "UTC")
      .format("YYYY-MM-DD HH:mm:SS");
    const convertedEndTime = moment.tz(endDateWithTime, timezone).format();
    const endDateInUtc = moment
      .tz(convertedEndTime, "UTC")
      .format("YYYY-MM-DD HH:mm:SS");
    return { startDateInUtc, endDateInUtc };
  } catch (e) {
    console.log("ERROR:: in utcToSpecificTimeZone", e);
  }
};

export const convertDateTimeToUtc = (timezone, startDate, endDate) => {
  try {
    const begin_time = startDate;
    const expire_time = endDate;
    const beginTimeFormat = moment(begin_time).format("YYYY-MM-DD HH:mm:ss");
    const expiryTimeFormat = moment(expire_time).format("YYYY-MM-DD HH:mm:ss");

    const convertedBeginTime = moment.tz(beginTimeFormat, timezone).format();
    const convertedExpiryTime = moment.tz(expiryTimeFormat, timezone).format();
    const startcurrent_time = moment.tz(convertedBeginTime, "UTC").format();
    const endcurrent_time = moment.tz(convertedExpiryTime, "UTC").format();
    return {
      startcurrent_time,
      endcurrent_time,
    };
  } catch (e) {
    console.log("ERROR:: in utcToSpecificTimeZone", e);
  }
};

const checkPasswordLength = (password) => {
  return password.length >= 8;
};

// Check for special characters
const checkSpecialCharacters = (password) => {
  const pattern = /[!@#$%^&*()+_\-=}{[\]|:;"/?.><,`~]/;
  return pattern.test(password);
};

// Check for an uppercase character
const checkUppercase = (password) => {
  const pattern = /[A-Z]/;
  return pattern.test(password);
};

const checkLowercase = (password) => {
  const pattern = /[a-z]/;
  return pattern.test(password);
};

// Check for a number
const checkNumber = (password) => {
  const pattern = /\d/;
  return pattern.test(password);
};

export const PasswordValidation = (password) => {
  let lengthValue = false;
  let special = false;
  let uppercase = false;
  let lowercase = false;
  let number = false;

  lengthValue = checkPasswordLength(password);
  special = checkSpecialCharacters(password);
  uppercase = checkUppercase(password);
  lowercase = checkLowercase(password);
  number = checkNumber(password);

  if (lengthValue && special && uppercase && lowercase && number) {
    return "";
  }
  return `Password Requirement  </br>
      <i ${
        lengthValue ? `class="fa fa-check-circle"` : `class="fa fa-times"`
      } aria-hidden="true" style=${
    lengthValue ? "color:green" : "color:red"
  }></i>
    minimum 8 characters </br>

    <i ${
      uppercase ? `class="fa fa-check-circle"` : `class="fa fa-times"`
    } aria-hidden="true" style=${uppercase ? "color:green" : "color:red"}></i>
    one uppercase </br>

    <i ${
      lowercase ? `class="fa fa-check-circle"` : `class="fa fa-times"`
    } aria-hidden="true" style=${lowercase ? "color:green" : "color:red"}></i>
    one lowercase </br>

    <i ${
      number ? `class="fa fa-check-circle"` : `class="fa fa-times"`
    } aria-hidden="true" style=${number ? "color:green" : "color:red"}></i>
    one number </br>

    <i ${
      special ? `class="fa fa-check-circle"` : `class="fa fa-times"`
    } aria-hidden="true" style=${special ? "color:green" : "color:red"}></i>
    one special character </br>`;
};

export const removeAccent = (data) => {
  return data?.normalize("NFD").replace(/\p{Diacritic}/gu, "");
};

export const removeSpecialChar = (data) => {
  return data?.replace(/[^a-zA-Z0-9 ]/g, "");
};

export const secondAndMinute = (expiration_time) => {
  const milisecond__diff = new Date(expiration_time).getTime();
  const cur_time = new Date().getTime();
  const second_remaining = Math.floor((milisecond__diff - cur_time) / 1000);
  const minutes_remaining = Math.floor(second_remaining / 60);
  const final_remain_second = second_remaining % 60;
  return { minutes: minutes_remaining, seconds: final_remain_second };
};

export const scroolToTop = () => {
  try {
    const tableElement = document.getElementsByClassName("rdt_Table")[0];
    tableElement?.scrollIntoView({ behavior: "smooth" });
  } catch (error) {}
};

export const getTodayDate = () => {
  const today = new Date();
  return moment(today).format("DD MMMM YYYY");
};

export const isSubdomain = (url) => {
  url = url.replace(/^\s+/, "");
  url = url.replace(/\s+$/, "");
  url = url.replace(/\\/g, "/");
  url = url.replace(/^http:\/\/|^https:\/\/|^ftp:\/\//i, "");
  url = url.replace(/^www\./i, "");
  url = url.replace(/\/(.*)/, "");
  let domain = "";
  let TLD = "";
  if (url.match(/\.[a-z]{2,4}$/i)) {
    url = url.replace(/\.[a-z]{2,4}$/i, "");
    domain = url.split(".")[0];
    TLD = url.split(".")[url.split(".").length - 1];
  }

  const isOtherDomainExist = domain !== "enforcement";
  return { isOtherDomainExist, domain, TLD };
};

export const phoneValidation = (rowData) => {
  if (Object.keys(rowData).length !== 0 && "phone" in rowData) {
    if (rowData && rowData.phone === "") {
      return "Phone number is required!";
    } else if (
      (rowData && rowData.phone && rowData.phone.length >= 11) ||
      (rowData && rowData.phone && rowData.phone.length < 10)
    ) {
      return "Please  enter valid Phone Number";
    } else if (!/^\d+$/.test(rowData.phone)) {
      return "Please  enter valid Phone Number";
    }
  }
  return "";
};
export const getDomain = () => {
  let domain = "";
  if (process.env.REACT_APP_MAIN_URL.includes("localhost")) {
    domain = "aparna";
  } else {
    const url = window.location.href;
    const domainDetails = isSubdomain(url);
    domain = domainDetails.domain;
  }
  return domain;
};
export default CustomContentAlert;
